import requester from '@/lib/axios';

export type Auth = {
  username: string;
  password: string;
  remember: boolean;
};

export async function auth({ username, password, remember }: Auth) {
  await requester().post(
    'auth/token/',
    {
      username,
      password,
      remember,
    },
    {
      withCredentials: true,
    },
  );
}

export async function getMe() {
  const { data } = await requester().get('users/me/');
  return data;
}

export async function logout() {
  await requester().post('auth/logout/');
}
